if (!customElements.get('bg-product-order-dock')) {
  customElements.define('bg-product-order-dock', class extends HTMLElement {
    connectedCallback() {
      this.setup = () => {
        const target = document.getElementById(this.dataset.target);
        if (!target || !('IntersectionObserver' in window)) return;
        this.observer?.disconnect();
        this.observer = new IntersectionObserver(entries => {
          this.classList.toggle('is-order-visible', entries[0].isIntersecting);
        }, {rootMargin: '-130px 0px -100px 0px'});
        this.observer.observe(target);
      };
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', this.setup, {once: true});
      } else {
        this.setup();
      }
    }
    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this.setup);
      this.observer?.disconnect();
    }
  });
}
